import React from 'react';
// import * as firebase from 'firebase';
import firebase from '../helper/firebase';

import { Link } from 'react-router-dom';

import Head from '../components/Head';
import JobCardHeader from '../components/JobCardHeader';
import JobCardContent from '../components/JobCardContent';
import JobCardReferees from '../components/JobCardReferees';
import UnpublishedJob from '../components/UnpublishedJob';
import EmptyState from '../components/EmptyState';
import LoggedOutCard from '../components/LoggedOutCard';
import Snack from '../components/Snack';
import ViewMoreFeedBtn from '../components/ViewMoreFeedBtn';
import { Title } from '../helper/consts';

import Fade from 'material-ui/transitions/Fade';

import {
	Button,
	Card,
	CardActions,
	// CardContent,
	CircularProgress,
	Divider,
	IconButton,
	Tooltip
} from 'material-ui';

import Collapse from 'material-ui/transitions/Collapse';

import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	actionSpace: {
		flex: '1 1 auto'
	},
	expandIcon: {
		transition: 'transform 0.3s ease'
	},
	expandIconExpanded: {
		transition: 'transform 0.3s ease',
		transform: 'rotate(180deg)'
	}
};

export default class MyOffers extends React.Component {
	constructor() {
		super();

		this.state = {
			loggedIn: false,
			authLoading: true,
			loading: true,
			archiveLoading: true,
			snackStatus: false,
			snackMessage: '',
			getVolume: 3,
			getVolumeIncrement: 1,
			getVolumeArchives: 3,
			getVolumeIncrementArchives: 1
		};
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.getInfo(user.uid);
				this.setState({
					uid: user.uid,
					user: user.providerData[0],
					loggedIn: true,
					authLoading: false,
					loading: true,
					jobs: {},
					archives: {}
				});
			} else {
				firebase
					.database()
					.ref(`myOffers/${this.state.uid}`)
					.off();
				this.setState({
					loggedIn: false,
					authLoading: false,
					loading: true,
					user: {},
					uid: '',
					jobs: {},
					archives: {}
				});
			}
		});
	}

	componentWillUnmount() {
		firebase
			.database()
			.ref(`myOffers/${this.state.uid}`)
			.off();
	}

	getInfo = uid => {
		const ref = firebase.database().ref();
		ref
			.child(`myCommissions/${uid}`)
			.once('value')
			.then(commissionSnap => {
				if (commissionSnap.val() !== null) {
					this.setState({ myCommissions: commissionSnap.val() });
				} else {
					this.setState({ myCommissions: {} });
				}
				ref
					.child(`myOffers/${uid}`)
					.orderByChild('archived')
					.equalTo(null)
					.limitToLast(this.state.getVolume)
					.on('value', snap => {
						if (snap.val() !== null) {
							let counter = snap.numChildren();
							let { jobs } = this.state;
							//TODO: use lodash isEqual to check if snap.val() is equal to jobs Object, if so open snack to inform user no more jobs
							if (Object.keys(jobs).length === Object.keys(snap.val()).length) {
								this.setState({
									snackStatus: true,
									snackMessage: 'No more jobs to load.'
								});
							}
							snap.forEach(myJobSnap => {
								let promises = [];
								if (!(myJobSnap.key in jobs)) {
									console.log(myJobSnap.key);
									// const jobPromise = ref.child(`jobs/${myJobSnap.key}`).once('value')
									const jobPromise = firebase
										.firestore()
										.collection('jobs')
										.doc(myJobSnap.key)
										.get()
										.then(jobSnap => {
											jobs[myJobSnap.key] = jobSnap.data();
											jobs[myJobSnap.key].oid = snap.val()[myJobSnap.key].oid;
											jobs[myJobSnap.key].shareCount = snap.val()[
												myJobSnap.key
											].shareCount;
											this.setState({ jobs });
										});
									promises.push(jobPromise);
								}
								counter--;
								if (counter === 0) {
									Promise.all(promises).then(() => {
										this.setState({
											loading: false,
											getVolume:
												this.state.getVolume + this.state.getVolumeIncrement
										});
									});
								}
							});
						} else {
							this.setState({
								snackStatus: true,
								snackMessage: 'No more jobs to load.',
								jobs: {},
								loading: false
							});
						}
					});
			});
	};

	getArchives = uid => {
		const ref = firebase.database().ref();
		ref
			.child(`myOffers/${uid}`)
			.orderByChild('archived')
			.equalTo(true)
			.limitToLast(this.state.getVolumeArchives)
			.once('value')
			.then(snap => {
				if (snap.val() !== null) {
					let counter = snap.numChildren();
					let { archives } = this.state;
					//TODO: use lodash isEqual to check if snap.val() is equal to jobs Object, if so open snack to inform user no more jobs
					if (Object.keys(archives).length === Object.keys(snap.val()).length) {
						this.setState({
							snackStatus: true,
							snackMessage: 'No more jobs to load.'
						});
					}
					snap.forEach(myJobSnap => {
						let promises = [];
						if (!(myJobSnap.key in archives)) {
							// const jobPromise = ref.child(`jobs/${myJobSnap.key}`).once('value')
							const jobPromise = firebase
								.firestore()
								.collection('jobs')
								.doc(myJobSnap.key)
								.get()
								.then(jobSnap => {
									if (jobSnap.data() !== null) {
										archives[myJobSnap.key] = jobSnap.data();
										archives[myJobSnap.key].oid = snap.val()[myJobSnap.key].oid;
										archives[myJobSnap.key].shareCount = snap.val()[
											myJobSnap.key
										].shareCount;
										this.setState({ archives });
									} else {
										console.log(`${myJobSnap.key} is missing`);
									}
								});
							promises.push(jobPromise);
						}
						counter--;
						if (counter === 0) {
							Promise.all(promises).then(() => {
								this.setState({
									archiveLoading: false,
									getVolumeArchives:
										this.state.getVolumeArchives +
										this.state.getVolumeIncrementArchives
								});
							});
						}
					});
				} else {
					this.setState({
						snackStatus: true,
						snackMessage: 'No more jobs to load.',
						archives: {},
						archiveLoading: false
					});
				}
			});
	};

	handleArchive = (jid, status) => {
		const { jobs, archives, uid } = this.state;
		firebase
			.database()
			.ref(`myOffers/${uid}/${jid}/`)
			.update({ archived: status })
			.then(() => {
				if (status) {
					delete jobs[jid];
				} else {
					delete archives[jid];
					this.setState({ viewArchived: false, archiveLoading: false });
				}
				this.setState({
					jobs,
					archives,
					snackStatus: true,
					snackMessage: `Job ${status ? 'archived' : 'unarchived'}.`
				});
			})
			.catch(err => {
				this.setState({
					snackStatus: true,
					snackMessage: 'Error: Job not archived'
				});
				console.log(err);
			});
	};

	renderJobs = () => {
		const { jobs, myCommissions } = this.state;
		let html = [];
		if (Object.keys(jobs).length === 0) {
			let card = (
				<EmptyState
					key="no jobs"
					subject={'No Offers'}
					message={'Start sharing an offer.'}
					btnDestination={'/'}
					btnMsg={'Home'}
				/>
			);
			html.push(card);
			return html;
		} else {
			let jids = Object.keys(jobs);
			jids.forEach(jid => {
				let job = jobs[jid];
				if (!job) return;
				let card = (
					<Fade key={job.jid} in={true}>
						<Card className="card">
							<JobCardHeader job={job} />
							<Divider light />
							{job.status !== 'published' ? null : (
								<JobCardContent job={job} wrap={true} />
							)}
							{job.status !== 'published' ? (
								<UnpublishedJob status={job.status} />
							) : null}

							<CardActions className="cardActions">
								<Link className="cardActionsBtn" to={`/Offer/${job.oid}`}>
									<Button raised>View</Button>
								</Link>
								{job.status !== 'published' ? (
									<Button
										className="cardActionsBtn"
										onClick={() => {
											this.handleArchive(job.jid, true);
										}}
										raised
										aria-label="Archive"
									>
										Archive
									</Button>
								) : null}
								{myCommissions[job.jid] !== undefined ? (
									<Link
										className="cardActionsBtn"
										to={`/Commission/${job.jid}`}
									>
										<Button raised color="primary">
											Commission
										</Button>
									</Link>
								) : null}
								{job.status !== 'published' ? null : (
									<div style={style.actionSpace} />
								)}
								{job.status !== 'published' ? null : (
									<div style={{ position: 'relative' }}>
										<Tooltip
											id="expandMoreIcon"
											title={
												this.state[`${job.jid}Expanded`]
													? 'Hide Referral Details'
													: 'View Referral Details'
											}
											placement="bottom"
										>
											<IconButton
												className="cardActionsBtn"
												onClick={() => {
													this.handleExpandClick(job.jid, job.oid);
												}}
												aria-expanded={this.state[`${job.jid}Expanded`]}
												aria-label="Show more"
												style={
													this.state[`${job.jid}Expanded`]
														? style.expandIconExpanded
														: style.expandIcon
												}
											>
												<ExpandMoreIcon />
											</IconButton>
										</Tooltip>
										{this.state[`${job.jid}Expanding`] ? (
											<CircularProgress
												size={52}
												style={{
													color: 'green',
													position: 'absolute',
													zIndex: 1
												}}
											/>
										) : null}
									</div>
								)}
							</CardActions>
							<Divider light />
							{job.status !== 'published' ? null : (
								<Collapse
									in={this.state[`${job.jid}Expanded`]}
									transitionDuration="auto"
									unmountOnExit
								>
									{this.state[`${job.jid}Expanded`] ? (
										<JobCardReferees
											shareCount={job.shareCount || 0}
											photoURL={this.state.user.photoURL}
											commission={
												myCommissions[job.jid] === undefined
													? job.commission / job.users.length
													: null
											}
											users={job.users}
											uid={this.state.uid}
											displayName={this.state.user.displayName}
										/>
									) : null}
								</Collapse>
							)}
						</Card>
					</Fade>
				);
				html.push(card);
			});
			if (html.length === 0) {
				let card = (
					<EmptyState
						key="no unarchived offers"
						subject={'No Unarchived Offers'}
						message={'Start sharing offers.'}
						btnDestination={'/'}
						btnMsg={'Home'}
					/>
				);
				html.push(card);
				return html;
			}
			return html;
		}
	};

	// handleExpandClick = (jid) => {
	//   this.setState({ jid: !this.state.jid});
	// };

	closeSnack = () => {
		this.setState({ snackStatus: false, snackMessage: '' });
	};

	handleViewArchivedBtnClick = status => {
		this.setState({
			viewArchived: status
		});
		if (
			status === true &&
			this.state.archives !== null &&
			Object.keys(this.state.archives).length === 0
		) {
			this.getArchives(this.state.uid);
		}
	};

	loadMore = type => {
		const { uid } = this.state;
		if (type === 'unarchived') {
			this.getInfo(uid);
		}
		if (type === 'archives') {
			this.getArchives(uid);
		}
	};

	handleExpandClick = (jid, oid) => {
		const { jobs } = this.state;
		if (jobs[`${jid}`].users) {
			this.setState({ [`${jid}Expanded`]: !this.state[`${jid}Expanded`] });
			return;
		}
		if (!this.state[`${jid}Expanding`]) {
			this.setState({
				[`${jid}Expanding`]: true
			});
		}
		firebase
			.firestore()
			.collection('offers')
			.doc(oid)
			.get()
			.then(snap => {
				let job = jobs[`${jid}`];
				job.users = snap.data().users;
				this.setState({
					jobs,
					[`${jid}Expanding`]: false,
					[`${jid}Expanded`]: !this.state[`${jid}Expanded`]
				});
			})
			.catch(err => {
				this.setState({
					[`${jid}Expanding`]: false,
					[`${jid}Expanded`]: !this.state[`${jid}Expanded`],
					snackStatus: true,
					snackMessage: 'Error: Please try again.'
				});
			});
	};

	renderArchives = () => {
		const { archives, myCommissions } = this.state;
		let html = [];
		let jids = Object.keys(archives);
		if (Object.keys(archives).length === 0) {
			html.push(
				<EmptyState
					key="no archived offers"
					subject={'No Archived Offers'}
					message={'Start Sharing Offers.'}
					btnDestination={'/'}
					btnMsg={'Home'}
				/>
			);
		} else {
			jids.forEach(jid => {
				let job = archives[jid];
				let card = (
					<Fade key={job.jid} in={true}>
						<Card className="card">
							<JobCardHeader job={job} />
							<Divider light />
							{job.status !== 'published' ? null : (
								<JobCardContent job={job} wrap={true} />
							)}
							{job.status !== 'published' ? (
								<UnpublishedJob status={job.status} />
							) : null}

							<CardActions className="cardActions">
								<Link className="cardActionsBtn" to={`/Offer/${job.oid}`}>
									<Button raised>View</Button>
								</Link>
								{job.status !== 'published' ? (
									<Button
										className="cardActionsBtn"
										onClick={() => {
											this.handleArchive(job.jid, null);
										}}
										raised
										aria-label="Unarchive"
									>
										Unarchive
									</Button>
								) : null}
								{myCommissions[job.jid] !== undefined ? (
									<Link
										className="cardActionsBtn"
										to={`/Commission/${job.jid}`}
									>
										<Button raised color="primary">
											Commission
										</Button>
									</Link>
								) : null}
								<div style={style.actionSpace} />
								{job.status !== 'published' ? null : (
									<Tooltip
										id="expandMoreIcon"
										title={
											this.state[`${job.jid}Expanded`]
												? 'Hide Referral Details'
												: 'View Referral Details'
										}
										placement="bottom"
									>
										<IconButton
											className="cardActionsBtn"
											onClick={() => {
												this.handleExpandClick(job.jid);
											}}
											aria-expanded={this.state[`${job.jid}Expanded`]}
											aria-label="Show more"
											style={
												this.state[`${job.jid}Expanded`]
													? style.expandIconExpanded
													: style.expandIcon
											}
										>
											<ExpandMoreIcon />
										</IconButton>
									</Tooltip>
								)}
							</CardActions>
						</Card>
					</Fade>
				);
				html.push(card);
			});
		}
		if (html.length === 0) {
			let card = (
				<EmptyState
					key="no archived offers"
					subject={'No Archived Offers'}
					message={'Start sharing offers.'}
					btnDestination={'/'}
					btnMsg={'Home'}
				/>
			);
			html.push(card);
			return html;
		}
		return html;
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Offers | ${Title}`} />
				<div id={this.state.loggedIn ? 'loggedInBody' : null} className="body">
					{(this.state.loading &&
						this.state.authLoading &&
						!this.state.loggedIn) ||
					(this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn) ? (
						<CircularProgress style={style.loading} size={75} />
					) : null}
					{this.state.loading &&
					!this.state.authLoading &&
					!this.state.loggedIn ? (
						<LoggedOutCard />
					) : null}

					{!this.state.loading && !this.state.authLoading && this.state.loggedIn
						? this.renderJobs()
						: null}
					{!this.state.loading &&
					!this.state.authLoading &&
					this.state.loggedIn ? (
						<ViewMoreFeedBtn
							key={'load more'}
							onClickfunction={() => {
								this.loadMore('unarchived');
							}}
							text={'Load More'}
						/>
					) : null}

					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						this.state.viewArchived && (
							<ViewMoreFeedBtn
								key={'view more'}
								onClickfunction={() => {
									this.handleViewArchivedBtnClick(false);
								}}
								text={'Hide Archived'}
							/>
						)}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.viewArchived && (
							<ViewMoreFeedBtn
								key={'view more'}
								onClickfunction={() => {
									this.handleViewArchivedBtnClick(true);
								}}
								text={'View Archived'}
							/>
						)}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						this.state.viewArchived &&
						this.state.archiveLoading && (
							<CircularProgress style={style.loading} size={75} />
						)}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						this.state.viewArchived &&
						!this.state.archiveLoading &&
						this.renderArchives()}
					{!this.state.loading &&
					!this.state.authLoading &&
					this.state.loggedIn &&
					this.state.viewArchived &&
					!this.state.archiveLoading ? (
						<ViewMoreFeedBtn
							key={'load more archives'}
							onClickfunction={() => {
								this.loadMore('archives');
							}}
							text={'Load More'}
						/>
					) : null}
					<Snack
						snackStatus={this.state.snackStatus}
						snackMessage={this.state.snackMessage}
						closeSnack={() => {
							this.closeSnack();
						}}
					/>
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/MyOffers.js